import constructActionTypes from 'common/utils/constructActionTypes';

import { reducerNamespace } from './reducerNamespace';

module.exports = constructActionTypes(
    {
        SET_FORM_LIST: null,
        SET_STATUS: null,
        SET_SEARCH_TERM: null,
        SET_FORM_LIBRARY_PAGE: null,
        SET_PAGE_LIMIT_REACHED: null,
        ADD_FORM_LIST: null,
        OPEN_SETTINGS_MODAL_ID: null,
        OPEN_DELETION_MODAL_ID: null,
        DELETE_FORM_LIBRARY: null,
    },
    reducerNamespace,
);
